import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function ContactButton() {
    
    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();

    return <button
        onClick={() => navigate(`${location.pathname}/Contact`)}
        className="contact-btn"
    >
        {t("button.booknow")}!
    </button>
}